import { getElementConstantHeight } from '@utils/elements';
import { halfPageManagerUpdateRepeaterHeights as updateRepeaterHeights } from './halfPageManagerUpdateRepeaterHeights';
import { halfPageManagerInsertRepeaters as insertRepeaters } from './halfPageManagerInsertRepeaters';
import { halfPageManagerState as state } from './halfPageManagerState';
import * as els from './halfPageManagerElements';
import * as consts from './halfPageManagerConstants';
import { isArticleDetailPage } from './halfPageManagerUtils';

// Inicializace repeater bannerů dle výšek bloků
export const halfPageManagerInitRepeaters = (): void => {
  if (els.topAside) {
    const topContentHeight: number = (els.topContent as HTMLElement).offsetHeight;

    // Kontrola, zda jsme na detailu článku pomocí utility funkce
    const isArticleDetail = isArticleDetailPage();

    if (els.bottomAside) {
      // Dva aside bloky s reklamami na stránce
      // Spodní obsahuje reklamy pozice 313 opakující se dle výšky spodního bloku
      state.setContentElement(els.bottomContent as HTMLElement);
      state.setElementToInsertRepeaterInto(els.bottomAside);
    } else {
      // Jeden aside blok s reklamami na stránce, obsahuje navíc pozici 311
      // Pokud je to možné, vložíme reklamy pozice 313 opakující se dle výšky bloku
      state.setContentElement(els.topContent as HTMLElement);
      state.setElementToInsertRepeaterInto(els.topAside);
    }

    if (
      // Pokud existuje spodní aside blok, zkusíme vložení vždy
      // Jinak pouze pokud je v postranním bloku místo, pozice 311 již může sama o sobě stačit
      (els.bottomAside || topContentHeight > consts.HALFPAGE_WRAPPER_MAX_HEIGHT) &&
      state.getContentElement()
    ) {
      // Zpracování detailu článku s dvěma obsahovými elementy
      if (isArticleDetail && els.articleMainContent && els.articleSecondaryContent) {
        Promise.all([
          getElementConstantHeight({ el: els.articleMainContent, intervalDelay: 50 }),
          getElementConstantHeight({ el: els.articleSecondaryContent, intervalDelay: 50 }),
        ]).then(
          ([mainHeight, secondaryHeight]: [number, number]) => {
            // Součet výšek obou obsahových bloků
            const combinedHeight = mainHeight + secondaryHeight;
            processContentHeight(combinedHeight);
          },
          () => {
            // Fallback na standardní výpočet, pokud Promise.all selže
            standardCalculation();
          }
        );
      } else {
        // Standardní výpočet pro ne-článkové stránky
        standardCalculation();
      }
    }
  }

  // Standardní výpočet pomocí jednoho obsahového elementu
  function standardCalculation() {
    getElementConstantHeight({
      el: state.getContentElement() as HTMLElement,
      intervalDelay: 50,
    }).then(
      (insertedContentHeight: number) => {
        processContentHeight(insertedContentHeight);
      },
      () => {}
    );
  }

  // Zpracování výšky obsahu a aktualizace repeaterů
  function processContentHeight(insertedContentHeight: number) {
    // Výpočet výšky pro topBanner v repeater bloku
    // Na iSportu bereme v úvahu, že topBanner je v wrapperu oproti uniwebu s miniplayerem v prvním <aside>
    const topAdHeightInRepeaterBlock: number =
      state.getContentElement() === els.topContent
        ? 0 // TopBanner je nyní v wrapperu s miniplayerem, takže ho nepočítáme zde
        : 0;

    // Výpočet dostupné výšky pro repeatery
    const availableHeightForRepeaterCalc: number =
      insertedContentHeight - consts.HALFPAGE_AD_HEIGHT - topAdHeightInRepeaterBlock;

    // Uložíme si výšku hlavního obsahu
    state.setContentHeight(insertedContentHeight);

    // Spočítáme si počet repeaterů ke vložení bez případného miniplayeru a horní reklamy
    state.setRepeaterBannerInsertCount(
      Math.floor(availableHeightForRepeaterCalc / consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT)
    );

    // Spočítáme výšku posledního banneru a nastavíme ji pro scrollování do konce obsahu
    state.setLastBannerHeight(
      state.getRepeaterBannerInsertCount() > 1
        ? state.getContentHeight() -
            state.getRepeaterBannerInsertCount() * consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT
        : state.getContentHeight()
    );

    // Vložíme repeatery a nastavíme jim výšky
    insertRepeaters();
    updateRepeaterHeights();
  }
};
